define('commons/post-button-handler',['jquery'], function($) {
    var PostButtonHandler = function(container, options){
        this.settings = $.extend({
            selectorTags: ["data-method='post'"], // array with attrs used to select a (links) elements inside container
            messageTag: "data-confirmation", //confirmation message attr
            urlTag : "data-url" // url attr
        }, options);
        
        this.container = $(container);
        this.unbind();
        this.bind();
    }
    
    PostButtonHandler.prototype.bind = function(){
        var self = this;
        $.each(this.settings.selectorTags, $.proxy(function(index, field) {
            self.container.find('a[' + field + ']').on('click.postbutton', $.proxy(self.onClick, this));
        }, this));
    }
    
    PostButtonHandler.prototype.unbind = function(){
        var self = this;
        $.each(this.settings.selectorTags, $.proxy(function(index, field) {
            self.container.find('a[' + field + ']').off('click.postbutton');
        }, this));
    }
    
    PostButtonHandler.prototype.onClick =  function(e) {
        var element = $(e.currentTarget);
        var confirmationMessage = element.attr(this.settings.messageTag);
        var url = element.attr(this.settings.urlTag);
        
        if (confirmationMessage == null || confirm(confirmationMessage)) {
            var form = document.createElement("form");
            form.method = 'post';
            form.action = url;
            $("body").append(form);
            form.submit();
        }
    };
    
    return PostButtonHandler;
});
